import React from 'react';
import { Button } from 'antd-v5';

const InquiryHeader = ({ createdDate, createdBy, assignedTo, status, onEdit }) => {
  return (
    <div className="qv-section">
      <div className="rolex-inquiry-header">
        <div className="rolex-inquiry-header__col rolex-inquiry-header__cell">
          <span className="rolex-inquiry-header__label">Inquiry Created</span>
          <span className="rolex-inquiry-header__value">{createdDate}</span>
          <span className="rolex-inquiry-header__creator">{createdBy}</span>
        </div>
        <div className="rolex-inquiry-header__cell rolex-inquiry-header__cell--center">
          <div className="rolex-inquiry-header__col">
            <span className="rolex-inquiry-header__label">Assigned To</span>
            <span className="rolex-inquiry-header__value">{assignedTo || '—'}</span>
          </div>
        </div>
        <div className="rolex-inquiry-header__cell rolex-inquiry-header__cell--center">
          <div className="rolex-inquiry-header__col">
            <span className="rolex-inquiry-header__label">Status</span>
            <span className="rolex-inquiry-header__value">{status}</span>
          </div>
        </div>
        <div className="rolex-inquiry-header__cell rolex-inquiry-header__cell--right">
          <Button type="primary" onClick={onEdit}>
            Edit
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InquiryHeader;
